import LayoutStore from './Layout.store';

export const layout = new LayoutStore();
